import * as React from "react";
import { useRouter } from "next/router";

export function ClientSideOnly({ children }: React.PropsWithChildren<unknown>) {
  const [isReady, setIsReady] = React.useState(false);
  const router = useRouter();
  React.useEffect(() => {
    if (router.isReady) {
      const params = new URLSearchParams(router.asPath.split("?")[1]);
      if ([...params.keys()].length === Object.keys(router.query).length) {
        setIsReady(true);
      }
    }
  }, [router.asPath, router.isReady, router.query]);

  // eslint-disable-next-line unicorn/no-null
  return isReady ? <>{children}</> : null;
}
